import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { Dynamic, type DynamicAction } from '@shared/registry';

import { type NotificationCardConfig } from './notification-card.types';

@Component({
  selector: 'app-notification-card',
  templateUrl: './notification-card.html',
  imports: [Dynamic, NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationCard {
  readonly config = input.required<NotificationCardConfig>();

  readonly action = output<DynamicAction>();

  protected onDismiss(): void {
    this.action.emit(this.config().dismissAction ?? { id: 'dismiss' });
  }

  protected onCardClick(): void {
    const action = this.config().action;
    if (action) {
      this.action.emit(action);
    }
  }
}
